import { Typography } from '@mui/material';
import toList from './ComponentUtil';
import './UnorderedList.scss'

function UnorderedList({ title, compensation}) {
    return (
        <div className="ul-items-wrp">
            <div className="ul-item-title">{title}</div>
            <div className="ul-item-details">
                <div className="unordered-list-wrp">
                    {toList(compensation, Typography)}
                </div>
            </div>
        </div>
    );
}

export default UnorderedList;